import { RenderState } from "../../RenderDriver/RenderModuleData/Design/RenderState";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { ShaderDefines2D } from "../shader/d2/ShaderDefines2D";
export var BlendMode;
(function (BlendMode) {
    BlendMode[BlendMode["invalid"] = 0] = "invalid";
    BlendMode[BlendMode["normal"] = 1] = "normal";
    BlendMode[BlendMode["add"] = 2] = "add";
    BlendMode[BlendMode["multiply"] = 3] = "multiply";
    BlendMode[BlendMode["screen"] = 4] = "screen";
    BlendMode[BlendMode["overlay"] = 5] = "overlay";
    BlendMode[BlendMode["light"] = 6] = "light";
    BlendMode[BlendMode["lighter"] = 7] = "lighter";
    BlendMode[BlendMode["mask"] = 8] = "mask";
    BlendMode[BlendMode["destinationOut"] = 9] = "destinationOut";
    BlendMode[BlendMode["addOld"] = 10] = "addOld";
    BlendMode[BlendMode["lighterOld"] = 11] = "lighterOld";
    BlendMode[BlendMode["sourceAlpha"] = 12] = "sourceAlpha";
})(BlendMode || (BlendMode = {}));
;
const TOINT = {
    [BlendMode.normal]: 0,
    [BlendMode.add]: 1,
    [BlendMode.multiply]: 2,
    [BlendMode.screen]: 3,
    [BlendMode.overlay]: 4,
    [BlendMode.light]: 5,
    [BlendMode.mask]: 6,
    [BlendMode.destinationOut]: 7,
    [BlendMode.lighter]: 1,
    [BlendMode.lighterOld]: 8,
    [BlendMode.addOld]: 8,
    [BlendMode.sourceAlpha]: 9
};
export class BlendModeHandler {
    static _init_() {
    }
    static setShaderData(blendType, shaderData, premultipliedAlpha = true) {
        let type = TOINT[blendType];
        switch (type) {
            case 1:
            case 3:
            case 5:
                shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
                shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE);
                break;
            case 2:
                shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_DST_COLOR);
                shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
                break;
            case 6:
                shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ZERO);
                shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_SRC_ALPHA);
                break;
            case 7:
                shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ZERO);
                shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ZERO);
                break;
            case 9:
                shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_SRC_ALPHA);
                shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
                break;
            default:
                shaderData.setInt(Shader3D.BLEND_SRC, premultipliedAlpha ? RenderState.BLENDPARAM_ONE : RenderState.BLENDPARAM_SRC_ALPHA);
                shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
        }
    }
    static initBlendMode(shaderData) {
        shaderData.setBool(Shader3D.DEPTH_WRITE, false);
        shaderData.setInt(Shader3D.DEPTH_TEST, RenderState.DEPTHTEST_OFF);
        shaderData.setInt(Shader3D.BLEND, RenderState.BLEND_ENABLE_ALL);
        shaderData.setInt(Shader3D.BLEND_EQUATION, RenderState.BLENDEQUATION_ADD);
        shaderData.setInt(Shader3D.BLEND_SRC, RenderState.BLENDPARAM_ONE);
        shaderData.setInt(Shader3D.BLEND_DST, RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA);
        shaderData.setNumber(ShaderDefines2D.UNIFORM_VERTALPHA, 1.0);
        shaderData.setInt(Shader3D.CULL, RenderState.CULL_NONE);
    }
}
